import { useConditionValueFieldPath } from '../fieldPaths';
import { useController } from '../../../contexts';
import { useValidateConditionValue } from '../../useValidateConditionValue';

export const useConditionValueController = () => {
  const fieldPath = useConditionValueFieldPath();
  const validate = useValidateConditionValue();

  return useController({
    name: fieldPath,
    rules: { validate },
  });
};
